/** Account state as the backend reports it: 1 enabled, 0 suspended, -1 disabled, -2 error. */
export enum AccountStatus {
  Enabled = 1,
  Suspend = 0,
  Disabled = -1,
  Error = -2,
}
